module.exports = __webpack_public_path__ + "static/media/banner_phone_2.29a7dc85.png";